import { COUNTRY_CODE } from '../config'

import {
    isPossiblePhoneNumber,
    isValidPhoneNumber,
    validatePhoneNumberLength,
    parsePhoneNumber
} from 'libphonenumber-js'

const PhoneUtils = {}

const formatPhoneNumberVN = (phone) => {
    if (phone.startsWith('+84')) {
        return `0${phone.substring(3)}`
    } if (phone.startsWith('84')) {
        return `0${phone.substring(2)}`
    }
    return phone;
}

const formatPhoneNumberLao = (phone) => {
    if (phone.startsWith('856')) {
        return `+${phone}`
    } else if (phone.startsWith('0')) {
        return `+856${phone.substring(1)}`
    } else if (phone.startsWith('+856')) {
        return phone
    }
    return `+856${phone}`;
}

PhoneUtils.isFormatUnitelNumberLao =(phoneNumber) =>{
    const REGEX_UNITEL = /^(\+856209)|^856209|^(\+8562080)|^8562080|^(\+8562081)|^8562081|^(\+8562082)|^8562082|^(\+8562083)|^8562083|^(\+8562084)|^8562084|^(\+8562085)|^8562085|^(\+8562086)|^8562086/;
    if(REGEX_UNITEL.test(phoneNumber)){
        return true;        
    }else{
        return false;
    }
}

PhoneUtils.formatPhoneNumber = (phone) => {
    switch (COUNTRY_CODE) {
        case 'LA':
            return formatPhoneNumberLao(phone)
        case 'VN':
        default:
            return formatPhoneNumberVN(phone)
    }
}

PhoneUtils.isValidPhoneNumberByCountry = (value) => {
    const phone = PhoneUtils.formatPhoneNumber(value)

    return isValidPhoneNumber(phone, COUNTRY_CODE)
}

export default PhoneUtils